import axios from "axios"
import { store } from "../redux/store"
import { dispatch } from "@wordpress/data"

const ACCESS_TOKEN = 'access_token'

async function getUserOpti() {
    return await axios.get(`/wp-admin/admin-ajax.php?action=obter_usuario_opti`)
        .then(res => {
            return { login: res.data.data.loginOpti, senha: res.data.data.passwordOpti }
        })
}

async function loginOpti({ login, senha, url }) {
    await axios.post(url, { login, senha })
        .then(async (res) => {
            const token = res.data.token
            
            sessionStorage.setItem(ACCESS_TOKEN, token)
        })
        .catch(err => {
            console.log("erro login.")
        })
}

class ManagerToken {
    static async loginAPI(url) {
        const userData =  await getUserOpti().then(res => { return res })
        await loginOpti({ login: userData.login, senha: userData.senha, url: url })
    }

    static definirTokens(accessToken) {
        sessionStorage.setItem(ACCESS_TOKEN, accessToken)
    }

    static get accessToken () {
        return sessionStorage.getItem(ACCESS_TOKEN)
    }
}

export default ManagerToken